import { Component, OnInit, ViewChild } from '@angular/core';
import { ModalController } from '@ionic/angular';

@Component({
  selector: 'app-intro',
  templateUrl: './intro.page.html',
  styleUrls: ['./intro.page.scss'],
})
export class IntroPage implements OnInit {
  @ViewChild('Slides', { static: false }) slidesCtrl;

  slideOpts = {
    initialSlide: 0,
    speed: 600,
    loop: true,
    pager: true,
    autoplay: true
  };

  slides: any = [];

  constructor(
    private modalCtrl: ModalController
  ) { }

  ngOnInit() {

    this.slides = [
      {
        imagen: './../../../assets/images/slide1.jpg',
        texto: 'TIENDAS'
      },
      {
        imagen: './../../../assets/images/slide2.jpg',
        texto: 'PRODUCTOS'
      },
      {
        imagen: './../../../assets/images/slide3.jpg',
        texto: 'COMPRAS'
      },
    ]


  }

  ionViewDidEnter() {
    setTimeout(() => {
      this.slidesCtrl.startAutoplay();
    }, 100);
  }

  slideChanged() {
    this.slidesCtrl.startAutoplay();
  }

  cerrar() {
    this.modalCtrl.dismiss();
  }

}
